export const copyToClipboard = async (content: string) => {
  if (window.isSecureContext && navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(content);
    } catch (error) {
      console.error('Failed to copy!', error);
    }
  } else {
    console.error('Not using HTTPS/localhost or Clipboard API not available.');
  }
};

export const copyRichHTML = async (HTML: string) => {
  const PLAINBLOB = new Blob([HTML], { type: 'text/plain' });
  const HTMLBLOB = new Blob([HTML], { type: 'text/html' });
  try {
    await navigator.clipboard.write([
      new ClipboardItem({ ['text/plain']: PLAINBLOB, ['text/html']: HTMLBLOB })
    ]);
    console.log('copied');
  } catch (error) {
    console.error('Failed to copy!', error);
  }
};
